import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Desktop' })({
    root: {
        boxSizing: 'border-box'
    },
    table: {
        tableLayout: 'fixed',
        '& th': {
            padding: '0 20px 32px 20px',
            borderColor: '#232323'
        },
        '& td': {
            color: '#fff',
            fontSize: 16,
            fontWeight: 400,
            lineHeight: '24px',
            borderColor: '#232323',
            padding: '24px 20px',
            ['& > svg']: {
                display: 'block'
            }
        },
        '& caption': {
            color: '#fff',
            fontSize: 16,
            fontWeight: 400,
            lineHeight: '24px',
            opacity: 0.5,
            padding: '32px 0 0 0'
        }
    }
});
